import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

// import Login from './pages/Login';
import adiantamento from './pages/Adiantamento';
import gestao from './pages/Adiantamento/gestaoAdiantamentos';
import novoAdiantamento from './pages/Adiantamento/novoAdiantamento';
import encContas from './pages/Adiantamento/encContas';
import trocaSenha from './pages/Login/changePassword';
import { isAuthenticated } from "./services/auth";
import Homepage from './pages';
import Logout from './pages/Logout';
import Importacao from './pages/Importacao';
import Irrigacao from './pages/Irrigacao';
import NovaIrrigacao from './pages/Irrigacao/novairrigacao';
import RelatoriosIrrigacao from './pages/Irrigacao/relatorios';
import IrrigAnPorProp from './pages/Irrigacao/IrrigAnPorProp';
import InsDetPorOpe from './pages/Irrigacao/InsDetPorOpe';
import InsAnPorOpe from './pages/Irrigacao/InsAnPorOpe';
import IrrigacaoOnline from './pages/IrrigacaoOnline';
import Orcamento from './pages/ControleDespesas';
import areas from './pages/ControleDespesas/areas';
import previsoes from './pages/ControleDespesas/previsoes';
import despesas from './pages/ControleDespesas/despesas';
import contas from './pages/ControleDespesas/contas';
import relatoriosOrcamento from './pages/ControleDespesas/relatorio'
import ferias from './pages/Ferias'
import statusFerias from './pages/Ferias/status'
import reforma from './pages/Reforma'
import especreforma from './pages/Reforma/especialidades'
import aprovacoes from './pages/ControleDespesas/aprovacoes'
import aprovacaosimplificada from './pages/ControleDespesas/aprovacaosimplificada'
import healthCheck from './components/HealthCheck'
import Menu from './components/Menu'
import Projetos from './pages/ControleDespesas/projetos'
import Auditoria from './pages/Auditoria'
import Rpa from './pages/Rpa'
import EfPorHora from './pages/Irrigacao/EfPorHora'
import Outorgas from './pages/Irrigacao/outorgas'
import OutorgasBDO from './pages/Irrigacao/outOutorgas'
import OutorgasIrrig from './pages/Irrigacao/opeOutorgas'
import ShowHideBDO from './pages/Irrigacao/showHideBdo'
import Escala from './pages/Escala'
import PorFrota from './pages/Escala/porFrota'
import Exportadores from './pages/Exportadores';
import NovoExportador from './pages/Exportadores/novoExportador'
import RodarExportador from './pages/Exportadores/rodarExportador'
import Categorias from './pages/Dashboards';
import Dashboards from './pages/Dashboards/dashboards';
import Dashboard from './pages/Dashboards/dashboard';
import Folha from './pages/Folha';
import DespesasViagens from './pages/DespesasViagens';
import Anomalias from './pages/Anomalias';
import PolicitaAbastecimento from './pages/PoliticasPrivacidade/abastecimento';
import Justificativa from './pages/ControleDespesas/justificativa';
import SyncCHB from './pages/ControleDespesas/syncchb';
import Consultartitulos from './pages/ControleDespesas/consultartitulos';
import ConsultarPrevisto from './pages/ControleDespesas/consultarprevisto';
import Login from './pages/Login/login';
import Empresas from './pages/Login/empresas';
import Transferencia from './pages/ControleDespesas/transferencia';
import Usuario from './pages/Usuario';
import ParamAreas from './pages/ControleDespesas/paramAreas';
import ManutCenario from './pages/ControleDespesas/manutcenario';
import ParametrosReforma from './pages/Reforma/parametros';
import AprovacaoReforma from './pages/Reforma/aprovacao';
import RelatorioReforma from './pages/Reforma/relatorio';
import Organograma from './pages/Organograma';
import OrganogramaManutencaoPrevisoes from './pages/Organograma/manutencaoPrevisoes';
import OrganogramaPrevisao from './pages/Organograma/previsao';
import IntegracaoOs from './pages/IntegracaoOs';
import IntegracaoOsFormulario from './pages/IntegracaoOs/formulario';
import IntegracaoOsListaFormularios from './pages/IntegracaoOs/listaFormularios';
import NotFound from './pages/notFound';

const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <>
            <Menu />
            <Route

                {...rest}
                render={props =>
                    isAuthenticated() ? (
                        <Component {...props} />
                    ) : (
                        <Redirect
                            to={{
                                pathname: '/',
                                state: { message: 'Usuário não autorizado' }
                            }}
                        />
                    )
                }
            />
        </>
    )
}

const Routes = () => (
    <Router>
        <Switch>

            {/* LOGIN */}
            <Route exact path="/" component={Login} />
            <Route exact path="/empresas" component={Empresas} />
            <PrivateRoute path="/home" component={Homepage} />

            {/* ADIANTAMENTO */}
            <PrivateRoute path="/adiantamento/:page?" component={adiantamento} />
            <PrivateRoute path="/importacao" component={Importacao} />
            <PrivateRoute path="/gestaoadiantamento/:id" component={gestao} />
            <PrivateRoute path="/novoadiantamento/:id?" component={novoAdiantamento} />
            <PrivateRoute path="/encontramento/:adiantamento_id" component={encContas} />

            {/* IRRIGAÇÃO */}
            <PrivateRoute path="/irrigacao" component={Irrigacao} />
            <PrivateRoute path="/novairrigacao/:id?" component={NovaIrrigacao} />
            <PrivateRoute path="/relatorios" component={RelatoriosIrrigacao} />
            <PrivateRoute path="/irriganporprop" component={IrrigAnPorProp} />
            <PrivateRoute path="/insdetporope" component={InsDetPorOpe} />
            <PrivateRoute path="/insanporope" component={InsAnPorOpe} />
            <PrivateRoute path="/efporhora" component={EfPorHora} />
            {/* <PrivateRoute path="/outorgas" component={Outorgas} /> */}
            {/* <PrivateRoute path="/out_irrig" component={OutorgasIrrig} />
            <PrivateRoute path="/out_bdo" component={OutorgasBDO} /> */}
            {/* <PrivateRoute path="/ocultabdo" component={ShowHideBDO} /> */}

            {/* IRRIGAÇÃO ONLINE */}
            <PrivateRoute path="/irrigacaoonline" component={IrrigacaoOnline} />

            {/* ORÇAMENTO */}
            {/* <PrivateRoute path="/orcamento" component={Orcamento} />
            <PrivateRoute path="/areas/cenario/:cenario" component={areas} />
            <PrivateRoute path="/despesas/cenario/:cenario/area/:area/conta/:conta/projeto/:projeto" component={despesas} />
            <PrivateRoute path="/contas/cenario/:cenario/area/:area" component={contas} />
            <PrivateRoute path="/previsao/cenario/:cenario/despesa/:despesa" component={previsoes} />
            <PrivateRoute path="/aprovacoes" component={aprovacoes} />
            <PrivateRoute path="/aprovacaosimplificada" component={aprovacaosimplificada} />
            <PrivateRoute path="/relatoriosorc" component={relatoriosOrcamento} />
            <PrivateRoute path="/projetos/cenario/:cenario/area/:area/conta/:conta" component={Projetos} />
            <PrivateRoute path="/justificativaorcamento" component={Justificativa} />
            <PrivateRoute path="/syncdespesaschb" component={SyncCHB} />
            <PrivateRoute path="/consultartitulos" component={Consultartitulos} />
            <PrivateRoute path="/consultarprevisto" component={ConsultarPrevisto} />
            <PrivateRoute path="/transferenciasaldo" component={Transferencia} />
            <PrivateRoute path="/parametrosareas" component={ParamAreas} />
            <PrivateRoute path="/manutcenario" component={ManutCenario} /> */}


            {/* ORÇAMENTO REFORMA */}
            <PrivateRoute path="/reforma" component={reforma} />
            <PrivateRoute path="/refespec/cenario/:cenario" component={especreforma} />
            <PrivateRoute path="/parametrosreforma" component={ParametrosReforma} />
            <PrivateRoute path="/aprovacoesreforma" component={AprovacaoReforma} />
            <PrivateRoute path="/relatoriosreforma" component={RelatorioReforma} />


            {/* FÉRIAS */}
            <PrivateRoute path="/ferias" component={ferias} />
            <PrivateRoute path="/statusferias" component={statusFerias} />

            {/* RPA */}
            <PrivateRoute path="/rpa" component={Rpa} />

            {/* ESCALA */}
            <PrivateRoute path="/escala" component={Escala} />
            <PrivateRoute path="/porfrota" component={PorFrota} />

            {/* EXPORTADORES */}
            <PrivateRoute path="/exportadores" component={Exportadores} />
            <PrivateRoute path="/novoexportador" component={NovoExportador} />
            <PrivateRoute path="/rodarexportador" component={RodarExportador} />

            {/* DASHBOARDS */}
            <PrivateRoute path="/categorias" component={Categorias} />
            <PrivateRoute path="/dashboards/categoria/:id" component={Dashboards} />
            <PrivateRoute path="/dashboard/:id" component={Dashboard} />
            <PrivateRoute path="/folha" component={Folha} />

            {/* DESPESAS DE VIAGEM */}
            <PrivateRoute path="/despesasdeviagem" component={DespesasViagens} />

            {/* ANOMALIAS */}
            <PrivateRoute path="/anomalias" component={Anomalias} />

            {/* CADASTRO DE USUÁRIOS */}
            <PrivateRoute path="/cadastrousuarios" component={Usuario} />
            <Route path="/trocasenha" component={trocaSenha} />

            {/* ORGANOGRAMA */}
            <PrivateRoute path="/organograma" component={Organograma} />
            <PrivateRoute path="/manutencaoprevisoes" component={OrganogramaManutencaoPrevisoes} />
            <PrivateRoute path="/previsao" component={OrganogramaPrevisao} />

            {/* INTEGRACAO OS */}
            <PrivateRoute path="/integracaoos" component={IntegracaoOs} />
            <PrivateRoute path="/formularioos" component={IntegracaoOsFormulario} />
            <PrivateRoute path="/listaformularios" component={IntegracaoOsListaFormularios} />

            {/* AUDITORIA DE CONEXÃO */}
            <PrivateRoute path="/auditoria" component={Auditoria} />

            {/* ROTAS PUBLICAS */}
            <Route path="/healthcheck" component={healthCheck} />
            <Route path="/logout" component={Logout} />

            {/* POLITICAS DE PRIVACIDADE */}
            <Route path="/politicas/abastecimento" component={PolicitaAbastecimento} />

            <Route path="*" component={NotFound}/>
        </Switch>
    </Router>
);

export default Routes;